import {
  CLEAR_MACHINE,
  CLEAR_MACHINE_FLAGS,
  CONGELAR_MACHINE_INIT,
  CONGELAR_MACHINE_SUCCESS,
  CREATE_MACHINE_INIT,
  CREATE_MACHINE_SUCCESS,
  DELETE_MACHINE_INIT,
  DELETE_MACHINE_SUCCESS,
  ERROR_MACHINE,
  GET_MACHINE_INIT,
  GET_MACHINE_SUCCESS,
  SEND_COMAND_MACHINE_INIT,
  SEND_COMAND_MACHINE_SUCCESS
} from 'src/redux/actionTypes';
import { IMachine } from 'src/integracoes/servicos/pgloader/modelos/IMachine';

const INIT_STATE = {
  machine: null as IMachine | null,
  loading: false,
  isError: false,
  msg: '',
  success: false,
  isCreated: false,
  isUpdated: false,
  isDeleted: false
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case GET_MACHINE_INIT:
      return { ...state, loading: true, success: false };
    case GET_MACHINE_SUCCESS:
      return { ...state, loading: false, machine: action.payload, success: true };
    case CREATE_MACHINE_INIT:
      return { ...state, loading: true, isCreated: false };
    case CREATE_MACHINE_SUCCESS: {
      const { isCreated, msg } = action.payload;
      return { ...state, loading: false, msg, isCreated };
    }
    case SEND_COMAND_MACHINE_INIT:
      return { ...state, isUpdated: false };
    case SEND_COMAND_MACHINE_SUCCESS: {
      const { isUpdated, msg } = action.payload;
      return { ...state, msg, isUpdated };
    }
    case DELETE_MACHINE_INIT:
      return { ...state, isDeleted: false };
    case DELETE_MACHINE_SUCCESS: {
      const { isDeleted, msg } = action.payload;
      return { ...state, isDeleted, msg };
    }
    case CONGELAR_MACHINE_INIT:
      return { ...state, loading: true, isUpdated: false };
    case CONGELAR_MACHINE_SUCCESS: {
      const { isUpdated, msg } = action.payload;
      return { ...state, loading: false, msg, isUpdated };
    }
    case ERROR_MACHINE: {
      const { msg } = action.payload;
      return { ...state, loading: false, msg, isError: true };
    }
    case CLEAR_MACHINE:
      return { ...INIT_STATE };
    case CLEAR_MACHINE_FLAGS:
      return {
        ...state,
        isCreated: false,
        isError: false,
        isDeleted: false,
        isUpdated: false,
        msg: ''
      };
    default:
      return { ...state };
  }
};
